module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_pin-77eea92382e386f5860a94818e3fc056.svg";